var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElementHeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H13.7143V4.57143H12.5714C12.2971 3.31429 12.4343 2.30857 12 1.92C11.5771 1.54286 10.5143 1.14286 9.14286 1.14286H8V13.7143C8 14.6286 8.13714 14.9143 8.42286 15.1314C8.70857 15.3486 9.32571 15.4971 10.2857 15.5657V16H3.40571V15.5657C4.4 15.4857 5.02857 15.3257 5.26857 15.0629C5.52 14.8114 5.71429 14.7314 5.71429 13.7143V1.14286H4.57143C3.26857 1.14286 2.11429 1.54286 1.64571 1.92C1.16571 2.29714 1.38286 3.30286 1.14286 4.57143H0V0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementHeader);
export default __webpack_public_path__ + "static/media/element_header.038ddf222ba56009a2a518ed8f39f548.svg";
export { ForwardRef as ReactComponent };